import { v4 as uuid } from "uuid";
import Styles from "./Styles";

export default class BaseElement {

  id = uuid();

  styles = new Styles();

  setId(id) {
    this.id = id;
  }

  setStyles(styles) {
    this.styles = styles;
  }

  /**
   * @param {boolean} tableColumnMode
   * @return {string}
   */
  getStyleAttribute(tableColumnMode = false) {
    const styles = this.styles.getStyle(tableColumnMode);

    return styles ? `style="${styles}"` : '';
  }
}